module.exports = __webpack_public_path__ + "static/Gavin-587158a4451d86f44e672156b6a9b27c.png";